import React from "react";

import Links from "../Links/Links";

export const DropdownLinks = ({ dropdown }: DropdownLinksProps) => {
  const DropdownLink = ({ text, link }: DropdownLink) => {
    if (link) {
      return <Links text={text} url={link} />;
    }

    return <></>;
  };

  if (dropdown?.links && dropdown.links.length > 0) {
    return (
      <>
        {window.innerWidth > 1024 ? (
          <li className={`navbar__links--dropdown`}>
            <p className="dropdown--label">{dropdown.text}</p>
            <div className="dropdown--links">
              {dropdown.links.map((e: DropdownLink) => (
                <DropdownLink text={e.text} link={e.link} />
              ))}
            </div>
          </li>
        ) : (
          dropdown.links.map((e: DropdownLink, index: number) => (
            <li
              key={`${e.text}-${index}`}
              className={`navbar__links--link ${e.text && e.text.toLowerCase().replaceAll(" ", "-")}`}
            >
              <DropdownLink text={e.text} link={e.link} />
            </li>
          ))
        )}
      </>
    );
  }

  return <></>;
};
